import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { observer } from 'mobx-react';
import React from 'react';
import ticketManagementConstants from '../../../core-utils/messages/TicketManagementConstants';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  Button,
  DottedText,
  SelectableChip,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

export interface TicketFilterModalProps {
  filter: any[];
  setFilters: any;
   
  handleApplyFilter: (data: any) => void;
}

export interface FilterOption {
  label: string;
  value: string;
  selected: boolean;
}

export interface FilterData {
  name: string;
  showAll: boolean;
  filters: FilterOption[];
}

const TicketFilterModal: React.FC<TicketFilterModalProps> = observer(
  ({ filter, setFilters, handleApplyFilter }) => {
    const useStyles = makeStyles()({
      container: {
        position: 'absolute',
        zIndex: 1000,
        left: '50%',
        right: '2%',
        width: '48%',
        border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        borderRadius: '8px',
        background: patientAccessTheme.palette.grey[100],
        margin: '20px 0',
        display: 'flex',
        padding: '20px',
        flexDirection: 'column',
      },
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '10px',
        width: '100%',
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      },
      flex: {
        display: 'flex',
        gap: '10px',
        flexWrap: 'wrap',
        alignItems: 'center',
      },
      actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
        margin: '15px 0px',
      },
    });
    const { classes } = useStyles();
    const constants = ticketManagementConstants.DETAILS_MODAL;

    //States

    //Functions
    const handleSelectedChip = (filterName: string, filterValue: string) => {
      setFilters((prev: any) =>
         
        prev.map((filterOption: any) =>
          filterOption.name === filterName
            ? {
                ...filterOption,
                 
                filters: filterOption.filters.map((filter: any) =>
                  filter.value === filterValue
                    ? { ...filter, selected: !filter.selected }
                    : filter,
                ),
              }
            : filterOption,
        ),
      );
    };

    const clearAllFilters = () => {
      setFilters((prev: any) =>
        prev.map((filterOption: any) => ({
          ...filterOption,
           
          filters: filterOption.filters.map((filter: any) => ({
            ...filter,
            selected: false,
          })),
        })),
      );
    };

    const applyFilters = () => {
      const selectedFilters = filter.reduce((acc, filterOption) => {
        const selectedValues = filterOption.filters
          .filter((filter: any) => filter.selected)
          .map((filter: any) => filter.value);
        if (selectedValues.length > 0) {
          acc[filterOption.name] = selectedValues;
        }
        return acc;
      }, {} as Record<string, string[]>);
      handleApplyFilter(selectedFilters);
    };

    const toggleShowAll = (name: string, showAll: boolean) => {
      setFilters((prev: any) =>
        prev.map((f: any) => (f.name === name ? { ...f, showAll } : f)),
      );
    };

    const renderChips = (filterOption: FilterData) => {
      return (
        <>
          {filterOption.filters.map(
            (temp, index) =>
              (index <= 3 || filterOption.showAll) && (
                <SelectableChip
                  key={temp.value}
                  isSelected={temp.selected}
                  label={temp.label}
                  handleOnClick={() => {
                    handleSelectedChip(filterOption.name, temp.value);
                  }}
                />
              ),
          )}
          {filterOption.filters.length > 4 && (
            <SelectableChip
              isSelected={false}
              label={
                filterOption.showAll ? (
                  <DottedText text={constants.showLess} />
                ) : (
                  `+${filterOption.filters.length - 4}`
                )
              }
              handleOnClick={() =>
                toggleShowAll(filterOption.name, !filterOption.showAll)
              }
            />
          )}
        </>
      );
    };

    return (
      <Grid container className={classes.container}>
        {filter.map((filterOption) => (
          <Grid key={filterOption.name} className={classes.root}>
            <Typography
              fontSize="12px"
              lineHeight="17px"
              fontType="semiBold"
              textColor={patientAccessTheme.palette.text.highemphasis}
            >
              {filterOption.name}
            </Typography>
            <Grid className={classes.flex}>{renderChips(filterOption)}</Grid>
          </Grid>
        ))}
        <Grid className={classes.actions}>
          <Button
            label={
              <Typography
                textColor={patientAccessTheme.palette.primary[500]}
                fontSize="12px"
                lineHeight="12px"
                fontType="medium"
              >
                {constants.clearFilter}
              </Typography>
            }
            variant="outlined"
            height="25px"
            width="80px"
            borderRadius="4px"
            onClick={clearAllFilters}
          />
          <Button
            label={
              <Typography
                textColor={patientAccessTheme.palette.status.white}
                fontSize="12px"
                lineHeight="12px"
                fontType="medium"
              >
                {constants.applyFilter}
              </Typography>
            }
            variant="contained"
            color="primary"
            height="25px"
            width="105px"
            borderRadius="4px"
            onClick={applyFilters}
          />
        </Grid>
      </Grid>
    );
  },
);

export default TicketFilterModal;
